import {connect} from 'react-redux';

import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {
  WorkspaceDisplayActionsEnum,
  WorkspaceDisplaySectionTrackingTypesEnum,
} from '../../../../libs/shared/core/src/models/tracking/contexts/workspaceTracking';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {RefinementOptionModel} from '../../../models/api/refinementOptionModel';
import {AppState} from '../../../store/appState';
import {startedEditingWorkspacesAction} from '../../../store/panels/inboxes/inboxesPanelActions';
import {
  createCommonWorkspaceItemSelectors,
  makeTeamGetIsUnread,
  WorkspaceItemContainerProps,
} from './workspaceItemContainerHelpers';
import {WorkspaceTeamItemContainerComponent} from './workspaceTeamItemContainerComponent';

interface WorkspaceTeamItemContainerProps extends Omit<WorkspaceItemContainerProps, 'team'> {
  team: TeamModel;
  selectedRefinement: RefinementOptionModel | undefined;
}

function getShouldShowRefinedResultsIndicator(_state: AppState, props: WorkspaceTeamItemContainerProps) {
  return props.selectedRefinement !== undefined;
}

const teamMapStateToProps = makeMapStateToProps<WorkspaceTeamItemContainerProps>()(() => ({
  ...createCommonWorkspaceItemSelectors(),
  isUnread: makeTeamGetIsUnread(),
  shouldShowRefinedResultsIndicator: getShouldShowRefinedResultsIndicator,
}));

const mapDispatchToProps = makeMapDispatchToProps<WorkspaceTeamItemContainerProps>()(({panelId}) => ({
  editWorkspaces: (hasRarelyViewedItems: boolean) => {
    trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_CLICK, {
      action: WorkspaceDisplayActionsEnum.VIEW_SIDEBAR,
      section: WorkspaceDisplaySectionTrackingTypesEnum.TEAM_VIEW,
    });
    return startedEditingWorkspacesAction(panelId, hasRarelyViewedItems);
  },
}));

export const WorkspaceTeamItemContainer = connect(
  teamMapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const onEditWorkspaces = () => {
      dispatchProps.editWorkspaces(stateProps.hasRarelyViewedItems);
    };
    return {
      ...stateProps,
      ...ownProps,
      onEditWorkspaces,
    };
  },
)(WorkspaceTeamItemContainerComponent);
